import { Input, InputNumber, Select, Switch } from "antd";
import { getSelectMetadataByCode } from "@ifa/utils";
import type { Question } from "./fnaBasicConfig";
import { formatMoney } from "./fnaBasicUtils";
import localStyles from "./FnaBasicInfoPlaceholder.module.css";

type Props = {
  question: Question;
  value: unknown;
  mode: "view" | "edit";
  onChange: (val: number | string | boolean | null) => void;
};

export function FnaField({ question, value, mode, onChange }: Props) {
  // Get options from metadata if metadataCode is provided, otherwise use static options
  const getOptions = () => {
    if (question.metadataCode) {
      const metadata = getSelectMetadataByCode(question.metadataCode);
      return metadata?.items?.map(item => ({
        label: item.name || "",
        value: item.key || "",
      })) || [];
    }
    return question.options || [];
  };

  const options = getOptions();

  const resolveOptionLabel = () => {
    if (!options.length) return undefined;
    const hit = options.find((opt) => opt.value === value);
    return hit?.label;
  };

  if (mode === "edit") {
    if (question.kind === "number") {
      return (
        <InputNumber
          controls={false}
          className={localStyles.fieldInput}
          value={value as number | undefined}
          placeholder={question.placeholder ?? "請輸入"}
          onChange={(val) => onChange(val)}
          min={0}
          style={{ width: "100%" }}
        />
      );
    }

    if (question.kind === "text") {
      return (
        <Input style={{ width: "100%" }} className={localStyles.fieldInput} value={(value as string) ?? ""} placeholder={question.placeholder ?? "請輸入"} onChange={(e) => onChange(e.target.value)} />
      );
    }

    if (question.kind === "select") {
      return (
        <Select
          style={{ width: "100%" }}
          className={localStyles.fieldInput}
          value={(value as string) || undefined}
          placeholder={question.placeholder ?? "請選擇"}
          options={options}
          onChange={(val) => onChange(val)}
          allowClear
        />
      );
    }

    if (question.variant === "inlineSwitch") {
      return (
        <div className={localStyles.inlineSwitch}>
          <div className={localStyles.inlineSwitchLabel}>{question.label}</div>
          <div className={localStyles.inlineSwitchLine} />
          <Switch size="large" checked={Boolean(value)} checkedChildren={question.checkedChildren} unCheckedChildren={question.unCheckedChildren} onChange={(checked) => onChange(checked)} />
        </div>
      );
    }
    return <Switch size="large" checked={Boolean(value)} checkedChildren={question.checkedChildren} unCheckedChildren={question.unCheckedChildren} onChange={(checked) => onChange(checked)} />;
  }

  // view mode
  if (question.kind === "number") {
    return <span className={localStyles.fieldValue}>{formatMoney(value as number)}</span>;
  }
  if (question.kind === "switch") {
    const optionLabel = resolveOptionLabel();
    if (question.variant === "inlineSwitch") {
      return (
        <div className={localStyles.inlineSwitch}>
          <div className={localStyles.inlineSwitchLabel}>{question.label}</div>
          <div className={localStyles.inlineSwitchLine} />
          <span className={localStyles.inlineSwitchValue}>{optionLabel ?? (value ? "是" : "否")}</span>
        </div>
      );
    }
    return <span className={localStyles.fieldValue}>{optionLabel ?? (value ? "是" : "否")}</span>;
  }
  const optionLabel = resolveOptionLabel();
  return <span className={localStyles.fieldValue}>{(optionLabel ?? (value as string)) || "--"}</span>;
}
